import { StatusBadge } from '../../components/ui.js';
import type { RbOrder } from '../../api/types.js';

/**
 * 주문 한 건의 상태 묶음 - 주문 상태 하나와 그 옆에 붙는 처리 표시들.
 *
 * 목록과 상세가 같은 판단(어떤 상태가 어떤 색인지, 송장대기를 언제 띄우는지)을
 * 따로 적고 있었다. 한쪽만 고치면 같은 주문이 두 화면에서 다르게 보인다.
 *
 * 색은 "손이 가야 하는 것"만 띄운다. 주문의 대부분은 배송완료라 그쪽을 가장
 * 차분하게 두고, 주문취소·배송정지처럼 눈에 띄어야 하는 것만 붉게 쓴다.
 */
function statusTone(status: string): 'neutral' | 'ok' | 'danger' {
  if (status === '배송완료') return 'ok';
  if (status === '주문취소') return 'danger';
  return 'neutral';
}

export function OrderStatusBadges({
  order,
  canceledCount = 0,
  showApplied = false,
}: {
  order: Pick<RbOrder, 'orderStatus' | 'trackingFlag' | 'pauseFlag' | 'deliveryResetFlag'>;
  /** 배송 취소된 경품 수. 상세에서만 안다. */
  canceledCount?: number;
  /** '배송 반영됨' 표시. 목록에서는 체크박스가 없는 것으로 이미 드러나므로 상세에서만 켠다. */
  showApplied?: boolean;
}) {
  const status = order.orderStatus ?? '';
  return (
    <span className="rb-status">
      {/* 상태가 비어 있는 주문이 실제로 있다 - 빈 배지 대신 '-' 만 둔다. */}
      {status ? <StatusBadge label={status} tone={statusTone(status)} /> : <span className="td-muted">-</span>}
      {order.trackingFlag && status !== '배송완료' && <StatusBadge label="송장대기" tone="warn" />}
      {order.pauseFlag && <StatusBadge label="배송정지" tone="danger" />}
      {showApplied && order.deliveryResetFlag && (
        <StatusBadge
          label="배송 반영됨"
          tone="info"
          title="비즈호스트에 등록해 배송 처리가 끝난 주문입니다. 목록에서 다시 고를 수 없습니다."
        />
      )}
      {canceledCount > 0 && <StatusBadge label={`배송 취소 ${canceledCount}건`} tone="danger" />}
    </span>
  );
}
